// app/components/approval/ApprovalAmount.tsx

import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";

interface ApprovalAmountProps {
  amount: number;
  currencyCode: string;
}

const ApprovalAmount = ({ amount, currencyCode }: ApprovalAmountProps) => {
  const { symbol, integer, decimal } = gxCurrencyFormat(
    amount,
    currencyCode,
    "en-US",
    {
      showSymbol: true,
      showCode: false,
    },
  );

  return (
    <span className="gx-approval-amount gx-p14-md">
      <span className="gx-approval-amount__symbol gx-p14-r">{symbol}</span>
      <span className="gx-approval-amount__integer gx-p14-b">{integer}</span>
      <span className="gx-approval-amount__decimal gx-p14-b">
        {decimal || ".00"}
      </span>
    </span>
  );
};

export default ApprovalAmount;
